import { Breadcrumb, Button, Card, Col, Flex, Layout, Row, Select, Space, Table } from "antd";
import { FormDatePicker, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import FormItem from "antd/es/form/FormItem";
import { ReactComponent as DownloadICon } from "../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import SalaryCalculationModal from "./reportModal/SalaryCalculationModal";


const SalaryCalculationGroup = ({
    reportTableSalary = [],
    departmentOptions = [],
    showReport,
    handleSearch = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('employee-id')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 200
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('working-day')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('wage-rate')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('salary-baht')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },
        {
            title: <div className="text-table">{t('overtime-working-days-hrs')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('total-income')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },
        {
            title: <div className="text-table">{t('leave-work')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('missing-work')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 200
        },
        {
            title: <div className="text-table">{t('total-expenses')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },
        {
            title: <div className="text-table">{t('sum-of-money')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },
        {
            title: <div className="text-table">{t('advance-payment')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },
        {
            title: <div className="text-table">{t('remaining')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "right",
            width: 200
        },

    ];
    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (

        <MainLayout>
            <SalaryCalculationModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t('report.header') },

                        {
                            title: t('salary_calculation_group.header'),
                        },
                        { title: t('report-on-the-results-of-calculation-not-salary-for-regular-periods') }
                    ]} />
                    <h2>{t('report-on-the-results-of-calculation-not-salary-for-regular-periods')}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    // initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (

                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0"
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        mode="multiple"
                                                        label={t('employee.label.department')}
                                                        // options={companyMock}
                                                        name="departmentId"
                                                        options={departmentOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        tree={true}
                                                        size="large"
                                                    // onChange={handleChange}
                                                    // options={options}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        picker="month"
                                                        label={t('month')}
                                                        dateFormat={"MMMM"}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                    />
                                                </Col>

                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                {/* <Flex>
                                    <Button
                                        style={{ backgroundColor: "#1e1e1e", color: "#ffff" }}>PDF</Button>
                                </Flex>
                                <Flex>
                                    <Button
                                        style={{ backgroundColor: "green", color: "#ffff" }}>EXCEL</Button>
                                </Flex>
                                <Flex>
                                    <Button
                                        style={{ backgroundColor: "green", color: "#ffff" }}>Text</Button>
                                </Flex>
                                <Flex>
                                    <Button style={{ backgroundColor: "var(--button-color)", color: "#ffff" }} onClick={handleSearch}>{t("search")}</Button>
                                </Flex> */}
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {
                                        showReport && (
                                            <Space direction="vertical" size={16}>
                                                <Flex justify="end">
                                                    <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                        <Flex gap={8}>
                                                            <DownloadICon />
                                                            <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                        </Flex>
                                                    </Button>
                                                </Flex>
                                                <Card style={{
                                                    backgroundColor: "white",
                                                    width: "100%",
                                                    border: "1px solid #EAECF0",
                                                }}>
                                                    <Space direction="vertical" size={8}>
                                                        <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('report-on-the-results-of-calculation-not-salary-for-regular-periods')}</span>
                                                        <TableAntd
                                                            columns={columns}
                                                            dataSource={reportTableSalary}
                                                            rowKey={(record) => record.id}
                                                            scroll={{ x: scrollX }}
                                                            tableLayout="fixed"
                                                        />
                                                    </Space>
                                                </Card>
                                            </Space>
                                        )
                                    }
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    );
}

export default SalaryCalculationGroup;
